export default "__VITE_ASSET__D638I3IU__"